import { useNavigate } from 'react-router-dom'
import arrowRight from '@/assets/svg/arrow-right.svg'
import { LangText } from '@/components'
import OutLink from '@/components/OutLink'
import { VIP_URL } from '@/constants'
import { PlatformEnum } from '@/service/api/types'
import { preFixImgUrl } from '@/utils'

const BANNER_BACKGROUND = '0d07ddfc84cd60204f8c1d1a8e07e4af.png'

const QUICK_LINKS = [
  {
    id: 'terms',
    icon: '5847681043812ec3a674e659a632a050.png',
    labelKey: 'vip.bottomBanner.links.terms',
  },
  {
    id: 'contact',
    icon: 'f5395a06c1bdd6471e4b11ad065722c4.png',
    labelKey: 'vip.bottomBanner.links.contact',
  },
] as const

const BottomBanner = () => {
  const navigate = useNavigate()

  const openQuickLink = (id: (typeof QUICK_LINKS)[number]['id']) => {
    if (id === 'terms') {
      navigate('/terms')
      return
    }

    window.location.href = 'mailto:info.japanmall@jdxjp.net'
  }

  return (
    <section className="group relative h-[480px] w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-cover transition-transform duration-700 ease-out group-hover:scale-105"
        style={{ backgroundImage: `url(${preFixImgUrl(BANNER_BACKGROUND)})` }}
        aria-hidden
      />

      <div className="relative z-[1] mx-auto flex h-full w-[1200px] flex-col items-center pt-[72px] text-white">
        <LangText
          lngKey="vip.bottomBanner.title"
          className="text-[36px] font-bold leading-[50px]"
        />
        <LangText
          lngKey="vip.bottomBanner.description"
          className="mt-[16px] text-[28px] leading-[40px]"
        />

        <OutLink platform={PlatformEnum.VIP} linUrl={VIP_URL}>
          <button
            type="button"
            className="mt-[32px] h-[48px] cursor-pointer rounded-full bg-white px-[30px] text-[20px] font-medium text-primary transition-[transform,box-shadow] duration-300 hover:scale-105 hover:shadow-[0_10px_24px_rgba(0,0,0,0.16)]"
          >
            <LangText lngKey="vip.bottomBanner.bookNow" />
          </button>
        </OutLink>

        <nav className="mt-[76px] flex h-[80px] w-[800px] items-center justify-center gap-[48px] overflow-hidden rounded-full border border-white/40 bg-white/15 backdrop-blur-[8px]">
          {QUICK_LINKS.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => openQuickLink(item.id)}
              className="group/link flex h-full cursor-pointer items-center justify-center gap-[12px] rounded-full px-[32px] text-[20px] text-white transition-colors duration-300 hover:bg-white/15"
            >
              <img
                src={preFixImgUrl(item.icon)}
                alt=""
                className="h-[40px] w-[40px] object-contain transition-transform duration-300 group-hover/link:scale-110"
                aria-hidden
              />
              <LangText lngKey={item.labelKey} />
              <img
                src={arrowRight}
                alt=""
                className="h-[14px] w-[14px] object-contain transition-transform duration-300 group-hover/link:translate-x-[2px]"
                aria-hidden
              />
            </button>
          ))}
        </nav>
      </div>
    </section>
  )
}

export default BottomBanner
